import React, { PureComponent } from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from 'app/components/panels/inp/pdf/PdfDocument';

export class Weather extends PureComponent {
    render() {
        return (
            <View>
                <Text style={styles.section_title}>Weather</Text>
            </View>
        );
    }
}
